import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { environment } from '../../../environments/environment';

@Injectable()
export class ConsultaConvenioService {
    constructor(public http: HttpClient,) { }

    traePostulantes(rut: any) {
        return this.http.get(`${environment.urlBase}/afiliados/rut/${rut}`,
            { headers: this.armaCabecera() }).toPromise();
    }
    traePostulacionesDisponiblesPorIdUsuario(usuario: any, rol: any) {
       
        return this.http.post(`${environment.urlApiPrestamo}/conveniosDisponibles/idUsuario/${usuario}/rol/${rol}`
            ,
            { headers: this.armaCabecera() }).toPromise();
    }
    traeUsuario(rut: any) {
        return this.http.get(`${environment.urlApiSolicitudes}/afiliados/rut/${rut}`,
            { headers: this.armaCabecera() }).toPromise();
    }
    postulacionesDisponiblesBuscador(usuario: any, rol: any, buscador: any, email: any) {

        return this.http.post(`${environment.urlApiPrestamo}/conveniosDisponibles/`,
            {

                email: email,
                rol: rol,
                idUsuarioAsig: usuario,
                numeroPagina: buscador?.currentPage,
                tamanioPagina: buscador?.itemsPerPage,
                idSolicitud: buscador?.idSolicitud,
                idRegion:buscador?.region,
                rut: buscador?.rut,
                fechaInicial: buscador?.fechaInicio?.split('-')?.reverse()?.join('-'),
                fechaFinal: buscador?.fechaFin?.split('-')?.reverse()?.join('-'),
                estado: buscador?.estado
            },
            { headers: this.armaCabecera() }).toPromise();
    }
    cambiarEstadoPostulacion(idPostulacion: any, estado: any) {
        return this.http.post(`${environment.urlApiPrestamo}/solicitudes/`,
            { id: idPostulacion, estado: estado }, { headers: this.armaCabecera() }).toPromise();
    }

    buscaPostulacionesPorFiltro(usuario: any, buscador: any) {
  
        return this.http.post(`${environment.urlApiPrestamo}/convenios/buscador/`
            , {
                numeroPagina: buscador?.currentPage,
                tamanioPagina: buscador?.itemsPerPage,
                idSolicitud: buscador?.idSolicitud,
                idUsuarioAsig: usuario,                
                idRegion: buscador?.region,
                rut: buscador?.rut,
                fechaInicial: buscador?.fechaInicio?.split('-')?.reverse()?.join('-'),
                fechaFinal: buscador?.fechaFin?.split('-')?.reverse()?.join('-'),
                estado: buscador?.estado
            },
            { headers: this.armaCabecera() }).toPromise();
    }
    traePostulacionesAsignadas(usuario: any, buscador: any) {
        return this.http.post(`${environment.urlApiPrestamo}/conveniosAsignados/`
            , {

                idUsuarioAsig: usuario,

                numeroPagina: buscador?.currentPage,
                tamanioPagina: buscador?.itemsPerPage
            },
            { headers: this.armaCabecera() }).toPromise();
    }
    postulacionesCodeudor(usuario: any, buscador: any) {
        console.log("!!!buscador!!!! ", buscador)
        console.log("!! usuario ", usuario)
        return this.http.post(`${environment.urlApiPrestamo}/conveniosAsignadosCodeudor/`
            , {
                idUsuarioAsig: usuario,
                numeroPagina: buscador?.currentPage,
                tamanioPagina: buscador?.itemsPerPage
            },

            { headers: this.armaCabecera() }).toPromise();

    }


    postulacionesMantenedorCodeudor(usuario: any, buscador: any, tipo: any) {    
        return this.http.post(`${environment.urlApiPrestamo}/conveniosConveniosyPrestamosCodeudor/`
            , {
                idUsuarioAsig: usuario,
                numeroPagina: buscador?.currentPage,
                tamanioPagina: buscador?.itemsPerPage,
                idTipoProducto:tipo
            },

            { headers: this.armaCabecera() }).toPromise();

    }

    traeConvenio(idConvenio: any) {
        return this.http.get(`${environment.urlApiPrestamo}/convenios/${idConvenio}`,
            { headers: this.armaCabecera() }).toPromise();
    }
    traeRegiones() {
        return this.http.get(`${environment.urlApiSolicitudes}/regiones`,
            { headers: this.armaCabecera() }).toPromise();
    }

    traeRegionesEspeciales()
    {
        return this.http.get(`${environment.urlApiUsuario}/regionesConvenios`, { headers: this.armaCabecera() } ).toPromise()
    }

    traeEstados() {
        return this.http.get(`${environment.urlApiPrestamo}/postulaciones/estados`,
            { headers: this.armaCabecera() }).toPromise();
    }
    traeArchivos(idPostulacion: any) {
        return this.http.get(`${environment.urlApiSolicitudes}/postulaciones/${idPostulacion}/archivo-adjunto/`,
            { headers: this.armaCabecera() }).toPromise()
    }
    asignaPostulacion(postulaciones: any, idEjecutivo: any) {
        console.log("postulaciones!!!!", postulaciones)
        return this.http.post(`${environment.urlApiPrestamo}/convenio/asignar/ejecutivo/${idEjecutivo}`,
            postulaciones, { headers: this.armaCabecera() }).toPromise()
    }
    traeProveedorSelect() {
        
        return this.http.get(`${environment.urlApiPrestamo}/getProveedores`,
            { headers: this.armaCabecera() }).toPromise();
    }
    traeCantidadCuotas() {

        return this.http.get(`${environment.urlApiPrestamo}/getCantidadCuotasConvenio`,
            { headers: this.armaCabecera() }).toPromise();
    }
    traeCantidadCuotasProveedor(proveedor: any) {
        return this.http.get(`${environment.urlApiPrestamo}/cuotasProveedor/${proveedor}`,
            { headers: this.armaCabecera() }).toPromise();
    }

    traeMontoTotalDisponible(idUsuario: any) {
        return this.http.get(`${environment.urlApiPrestamo}/totalDisponible/${idUsuario}`,
            { headers: this.armaCabecera() }).toPromise();
    }
    calcularPlanPagoConvenio(monto: any, cantidadCuotas: any) {
        return this.http.get(`${environment.urlApiPrestamo}/calculaPlanPago/convenio/${monto}/cuotas/${cantidadCuotas}`,
            { headers: this.armaCabecera() }).toPromise();
    }
    traeCategoriaConvenio() {
        return this.http.get(`${environment.urlApiPrestamo}/getTipoConvenio`,
            { headers: this.armaCabecera() }).toPromise();
    }
    traeProveedoresPorRegionyTipo(region: any, cat: any) {
        return this.http.get(`${environment.urlApiPrestamo}/proveedor/${region}/segun/${cat}`,
            { headers: this.armaCabecera() }).toPromise();
    }
    traeProveedoresPorId(idProveedor) {
        return this.http.get(`${environment.urlApiPrestamo}/proveedor/${idProveedor}`,
            { headers: this.armaCabecera() }).toPromise();
    }
    armaCabecera() {
        return new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem("jwt"),
            'Access-Control-Allow-Methods': 'GET, POST, PUT, PATCH, DELETE',
            'Access-Control-Allow-Origin': '*',
        })
    }
}